(function () {
  'use strict';

  const modal = document.getElementById('tournamentFilterModal');
  const overlay = document.getElementById('tournamentFilterModalOverlay');
  if (!modal || !overlay) return;

  const stateHidden = document.getElementById('state');
  const cityHidden = document.getElementById('city');
  const ratingHidden = document.getElementById('rating');
  const tableSizeHidden = document.getElementById('table_size');
  const buyInMinHidden = document.getElementById('buy_in_min');
  const buyInMaxHidden = document.getElementById('buy_in_max');

  const stateSearch = document.getElementById('tournament-modal-state');
  const citySearch = document.getElementById('tournament-modal-city');
  const ratingSearch = document.getElementById('tournament-modal-rating');
  const sizeSearch = document.getElementById('tournament-modal-size');

  const stateList = document.getElementById('tournamentModalStateList');
  const cityList = document.getElementById('tournamentModalCityList');
  const ratingList = document.getElementById('tournamentModalRatingList');
  const sizeList = document.getElementById('tournamentModalSizeList');
  const statePills = document.getElementById('tournamentModalStateSelectedPills');
  const cityPills = document.getElementById('tournamentModalCitySelectedPills');
  const ratingPills = document.getElementById('tournamentModalRatingSelectedPills');
  const sizePills = document.getElementById('tournamentModalSizeSelectedPills');
  const selectableLists = [stateList, cityList, ratingList, sizeList].filter(Boolean);

  const buyInMinInput = document.getElementById('tournament-modal-buy-in-min');
  const buyInMaxInput = document.getElementById('tournament-modal-buy-in-max');
  const applyBtn = modal.querySelector('.filter-modal-apply');
  const resultsCountEl = document.getElementById('tournament-results-count');

  const filterData = window.tournamentFilterData || {};
  const filterMetadata = window.filterMetadata || {};

  const stateCityMapping =
    filterData.stateCityMapping ||
    filterMetadata.state_city_mapping ||
    filterMetadata.stateCityMapping ||
    {};

  const normalizeRegionValue = (value) => String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

  const STATE_NAME_MAP = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
    HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
    KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
    MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri',
    MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
    NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio',
    OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
    SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
    VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
    DC: 'District of Columbia'
  };

  const STATE_NAME_TO_ABBREV = Object.keys(STATE_NAME_MAP).reduce((acc, key) => {
    acc[STATE_NAME_MAP[key].toLowerCase()] = key;
    return acc;
  }, {});

  const ensureArray = (value) => (Array.isArray(value) ? value : []);

  const getAvailableStates = () => ensureArray(
    filterData.availableStates ||
    filterData.available_states ||
    filterMetadata.available_states ||
    filterMetadata.availableStates
  );

  const getAvailableCities = () => ensureArray(
    filterData.availableCities ||
    filterData.available_cities ||
    filterMetadata.available_cities ||
    filterMetadata.availableCities
  );

  const getAvailableRatings = () => ensureArray(
    filterData.availableRatings ||
    filterData.available_rating_systems ||
    filterMetadata.available_rating_systems ||
    filterMetadata.availableRatings
  );

  const getAvailableTableSizes = () => ensureArray(
    filterData.availableTableSizes ||
    filterData.available_table_sizes ||
    filterMetadata.available_table_sizes ||
    filterMetadata.availableTableSizes
  );

  const getStateAbbrev = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';

    const upper = raw.toUpperCase();
    if (STATE_NAME_MAP[upper]) return upper;

    const mappedFromName = STATE_NAME_TO_ABBREV[normalizeRegionValue(raw)];
    if (mappedFromName) return mappedFromName;

    const normalized = normalizeRegionValue(raw);
    const matched = getAvailableStates().find((option) => normalizeRegionValue(option) === normalized);
    if (matched) {
      const matchedRaw = String(matched).trim();
      const matchedUpper = matchedRaw.toUpperCase();
      if (STATE_NAME_MAP[matchedUpper]) return matchedUpper;
      const matchedFromName = STATE_NAME_TO_ABBREV[normalizeRegionValue(matchedRaw)];
      if (matchedFromName) return matchedFromName;
      return matchedRaw;
    }

    return upper;
  };

  const getStateDisplayName = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';

    const abbrev = getStateAbbrev(raw);
    if (abbrev && STATE_NAME_MAP[abbrev]) return STATE_NAME_MAP[abbrev];

    const normalized = normalizeRegionValue(raw);
    const matched = getAvailableStates().find((option) => normalizeRegionValue(option) === normalized);
    return String(matched || raw).trim();
  };

  const formatRating = (value) => {
    const raw = String(value || '').trim();
    const map = {
      apa_skill_level: 'APA',
      fargo_rate: 'Fargo',
      bca_rating: 'BCA',
      tap_handicap: 'TAP',
      usapl_rating: 'USAPL',
      in_house_handicap: 'In-house',
      no_handicap_open: 'Open'
    };
    return map[raw] || raw;
  };

  const formatTableSize = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    const normalized = raw.toLowerCase().replace(/\s+/g, ' ');
    if (normalized.includes('snooker')) return 'Snooker';
    if (normalized.includes('carom')) return 'Carom';
    const match = normalized.match(/\b(6|7|8|9|10)\s*'?\s*(foot|ft)?\b/);
    if (match) return `${match[1]}'`;
    return raw;
  };

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const suppressBrowserAutofill = (inputs) => {
    (inputs || []).forEach((input) => {
      if (!input) return;
      const id = input.id || 'filter-input';
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('autocapitalize', 'none');
      input.setAttribute('spellcheck', 'false');
      input.setAttribute('data-lpignore', 'true');
      input.setAttribute('data-1p-ignore', 'true');
      if (!input.getAttribute('name') || /state|city|country|address/i.test(input.getAttribute('name'))) {
        input.setAttribute('name', `${id}-typeahead`);
      }
    });
  };

  const debounce = (fn, waitMs = 220) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), waitMs);
    };
  };

  const parseItemsCount = (text) => {
    const match = String(text || '').match(/(\d+)/);
    return match ? Number.parseInt(match[1], 10) : 0;
  };

  const updateApplyButtonLabel = () => {
    if (!applyBtn) return;
    const currentCount = resultsCountEl ? parseItemsCount(resultsCountEl.textContent) : 0;
    applyBtn.textContent = `See ${currentCount} items`;
  };

  const renderCheckboxList = ({ listEl, name, options, selectedValues, mapLabel, onSelect }) => {
    if (!listEl) return;

    if (!options.length) {
      listEl.innerHTML = '<label><span>No options</span></label>';
      return;
    }

    const selected = Array.isArray(selectedValues) ? selectedValues :
      (selectedValues ? String(selectedValues).split(',').map(v => v.trim()).filter(Boolean) : []);

    listEl.innerHTML = options.map((option) => {
      const key = String(option.key);
      const label = mapLabel ? mapLabel(option) : option.label;
      const checked = selected.includes(key) ? 'checked' : '';
      return `
        <label>
          <input type="checkbox" name="${name}" value="${escapeHtml(key)}" ${checked} />
          <span>${escapeHtml(label)}</span>
        </label>
      `;
    }).join('');

    listEl.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
      input.addEventListener('change', () => {
        if (typeof onSelect === 'function') onSelect();
      });
    });
  };

  const buildStateOptions = (query = '') => {
    const q = query.trim().toLowerCase();
    const stateCodes = getAvailableStates().map((s) => getStateAbbrev(s) || s).filter(Boolean);
    const deduped = Array.from(new Set(stateCodes));
    return deduped
      .map((code) => ({ key: code, label: getStateDisplayName(code) }))
      .filter((opt) => !q || opt.label.toLowerCase().includes(q) || opt.key.toLowerCase().includes(q))
      .sort((a, b) => a.label.localeCompare(b.label));
  };

  const getEffectiveState = () => {
    const stateChecked = Array.from(modal.querySelectorAll('input[name="tournament-modal-state-group"]:checked'));
    if (stateChecked.length > 0) return stateChecked[0].value;
    const hiddenValue = (stateHidden && stateHidden.value) || '';
    if (hiddenValue) return hiddenValue.split(',')[0];
    return '';
  };

  const buildCityOptions = (query = '') => {
    const q = query.trim().toLowerCase();
    const selectedState = getEffectiveState();
    const cities = selectedState && stateCityMapping[selectedState]
      ? stateCityMapping[selectedState]
      : getAvailableCities();

    return ensureArray(cities)
      .map((city) => ({ key: city, label: city }))
      .filter((opt) => !q || opt.label.toLowerCase().includes(q))
      .sort((a, b) => a.label.localeCompare(b.label));
  };

  const buildRatingOptions = (query = '') => {
    const q = query.trim().toLowerCase();
    return getAvailableRatings()
      .map((r) => ({ key: r, label: formatRating(r) }))
      .filter((opt) => !q || opt.label.toLowerCase().includes(q) || opt.key.toLowerCase().includes(q));
  };

  const buildSizeOptions = (query = '') => {
    const q = query.trim().toLowerCase();
    const formattedOptions = getAvailableTableSizes()
      .map((size) => {
        const key = String(size || '').trim();
        const label = formatTableSize(key);
        return {
          key,
          label,
          searchText: `${key} ${label}`.toLowerCase()
        };
      })
      .filter((opt) => opt.key);

    const dedupedByLabel = Array.from(
      formattedOptions.reduce((map, option) => {
        const dedupeKey = option.label.toLowerCase();
        if (!map.has(dedupeKey)) map.set(dedupeKey, option);
        return map;
      }, new Map()).values()
    );

    return dedupedByLabel.filter((opt) => !q || opt.searchText.includes(q));
  };

  const renderStateList = () => {
    renderCheckboxList({
      listEl: stateList,
      name: 'tournament-modal-state-group',
      options: buildStateOptions((stateSearch && stateSearch.value) || ''),
      selectedValues: (stateHidden && stateHidden.value) || '',
      onSelect: () => {
        refreshModalPills();
        renderCityList();
        autoApplyAndRefresh();
      }
    });
    refreshModalPills();
  };

  const renderCityList = () => {
    renderCheckboxList({
      listEl: cityList,
      name: 'tournament-modal-city-group',
      options: buildCityOptions((citySearch && citySearch.value) || ''),
      selectedValues: (cityHidden && cityHidden.value) || '',
      onSelect: () => {
        refreshModalPills();
        autoApplyAndRefresh();
      }
    });
    refreshModalPills();
  };

  const renderRatingList = () => {
    renderCheckboxList({
      listEl: ratingList,
      name: 'tournament-modal-rating-group',
      options: buildRatingOptions((ratingSearch && ratingSearch.value) || ''),
      selectedValues: (ratingHidden && ratingHidden.value) || '',
      onSelect: () => {
        refreshModalPills();
        autoApplyAndRefresh();
      }
    });
    refreshModalPills();
  };

  const renderSizeList = () => {
    renderCheckboxList({
      listEl: sizeList,
      name: 'tournament-modal-size-group',
      options: buildSizeOptions((sizeSearch && sizeSearch.value) || ''),
      selectedValues: (tableSizeHidden && tableSizeHidden.value) || '',
      onSelect: () => {
        refreshModalPills();
        autoApplyAndRefresh();
      }
    });
    refreshModalPills();
  };

  const syncModalFromHidden = () => {
    if (buyInMinInput) buyInMinInput.value = (buyInMinHidden && buyInMinHidden.value) || '';
    if (buyInMaxInput) buyInMaxInput.value = (buyInMaxHidden && buyInMaxHidden.value) || '';
  };

  const hideAllSelectableLists = () => {
    selectableLists.forEach((listEl) => listEl.classList.remove('is-open'));
  };

  const showSelectableList = (listEl) => {
    hideAllSelectableLists();
    if (listEl) listEl.classList.add('is-open');
  };

  const renderPills = ({ containerEl, values, type, mapLabel }) => {
    if (!containerEl) return;

    if (!values.length) {
      containerEl.innerHTML = '';
      return;
    }

    containerEl.innerHTML = values.map((value) => {
      const label = typeof mapLabel === 'function' ? mapLabel(value) : value;
      return `
        <div class="filter-pill" data-pill-type="${escapeHtml(type)}" data-pill-value="${escapeHtml(value)}">
          <span>${escapeHtml(label)}</span>
          <button type="button" class="remove-pill-btn" aria-label="Remove ${escapeHtml(label)}">&times;</button>
        </div>
      `;
    }).join('');
  };

  const getCheckedValuesArray = (name) => Array.from(
    modal.querySelectorAll(`input[name="${name}"]:checked`)
  ).map((input) => input.value);

  const refreshModalPills = () => {
    renderPills({
      containerEl: statePills,
      values: getCheckedValuesArray('tournament-modal-state-group'),
      type: 'tournament-modal-state-group',
      mapLabel: (value) => getStateDisplayName(value)
    });

    renderPills({
      containerEl: cityPills,
      values: getCheckedValuesArray('tournament-modal-city-group'),
      type: 'tournament-modal-city-group'
    });

    renderPills({
      containerEl: ratingPills,
      values: getCheckedValuesArray('tournament-modal-rating-group'),
      type: 'tournament-modal-rating-group',
      mapLabel: (value) => formatRating(value)
    });

    renderPills({
      containerEl: sizePills,
      values: getCheckedValuesArray('tournament-modal-size-group'),
      type: 'tournament-modal-size-group',
      mapLabel: (value) => formatTableSize(value)
    });
  };

  const openModal = () => {
    syncModalFromHidden();
    renderStateList();
    renderCityList();
    renderRatingList();
    renderSizeList();
    hideAllSelectableLists();
    updateApplyButtonLabel();

    overlay.style.display = 'block';
    modal.classList.add('active');
    document.body.classList.add('plp-tournament-modal-open');
    requestAnimationFrame(() => {
      modal.style.left = '0';
    });

    // Scroll content to top
    const mc = modal.querySelector('.filter-modal-content');
    if (mc) {
      setTimeout(() => {
        mc.scrollTop = 0;
      }, 0);
    }
  };

  const closeModal = () => {
    hideAllSelectableLists();
    modal.style.left = '-100%';
    document.body.classList.remove('plp-tournament-modal-open');
    setTimeout(() => {
      overlay.style.display = 'none';
      modal.classList.remove('active');
    }, 300);
  };

  const getCheckedValues = (name) => {
    const checked = Array.from(modal.querySelectorAll(`input[name="${name}"]:checked`));
    return checked.map(input => input.value).join(',');
  };

  const applyModalFilters = () => {
    const modalState = getCheckedValues('tournament-modal-state-group');
    const modalCity = getCheckedValues('tournament-modal-city-group');
    const modalRating = getCheckedValues('tournament-modal-rating-group');
    const modalSize = getCheckedValues('tournament-modal-size-group');

    if (stateHidden) stateHidden.value = modalState || '';
    if (cityHidden) cityHidden.value = modalCity || '';
    if (ratingHidden) ratingHidden.value = modalRating || '';
    if (tableSizeHidden) tableSizeHidden.value = modalSize || '';

    if (buyInMinHidden) buyInMinHidden.value = (buyInMinInput && buyInMinInput.value) ? String(buyInMinInput.value).trim() : '';
    if (buyInMaxHidden) buyInMaxHidden.value = (buyInMaxInput && buyInMaxInput.value) ? String(buyInMaxInput.value).trim() : '';

    if (typeof window.refreshTournamentFilterUI === 'function') {
      window.refreshTournamentFilterUI();
    }

    if (typeof window.applyFilters === 'function') {
      window.applyFilters();
    }

    setTimeout(updateApplyButtonLabel, 250);
  };

  const autoApplyModalFilters = debounce(() => {
    applyModalFilters();
  }, 220);

  const autoApplyAndRefresh = () => {
    autoApplyModalFilters();
  };

  window.openTournamentFilterModal = openModal;
  window.closeTournamentFilterModal = closeModal;
  window.applyTournamentFiltersFromModal = applyModalFilters;

  // Bind More button and close button event listeners
  const moreBtn = document.getElementById('tournamentMoreBtn');
  if (moreBtn) {
    moreBtn.addEventListener('click', openModal);
  }

  const closeBtn = modal.querySelector('.filter-modal-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  if (applyBtn) {
    // Flyout filters auto-apply; button now just closes the flyout.
    applyBtn.addEventListener('click', closeModal);
  }

  if (buyInMinInput) {
    buyInMinInput.addEventListener('input', autoApplyAndRefresh);
  }

  if (buyInMaxInput) {
    buyInMaxInput.addEventListener('input', autoApplyAndRefresh);
  }

  if (resultsCountEl && window.MutationObserver) {
    const resultsObserver = new MutationObserver(updateApplyButtonLabel);
    resultsObserver.observe(resultsCountEl, { childList: true, subtree: true, characterData: true });
  }

  const bindSearch = () => {
    if (stateSearch) {
      stateSearch.addEventListener('input', () => {
        renderStateList();
        showSelectableList(stateList);
      });
      stateSearch.addEventListener('focus', () => {
        renderStateList();
        showSelectableList(stateList);
      });
      stateSearch.addEventListener('click', () => {
        renderStateList();
        showSelectableList(stateList);
      });
    }

    if (citySearch) {
      citySearch.addEventListener('input', () => {
        renderCityList();
        showSelectableList(cityList);
      });
      citySearch.addEventListener('focus', () => {
        renderCityList();
        showSelectableList(cityList);
      });
      citySearch.addEventListener('click', () => {
        renderCityList();
        showSelectableList(cityList);
      });
    }

    if (ratingSearch) {
      ratingSearch.addEventListener('input', () => {
        renderRatingList();
        showSelectableList(ratingList);
      });
      ratingSearch.addEventListener('focus', () => {
        renderRatingList();
        showSelectableList(ratingList);
      });
      ratingSearch.addEventListener('click', () => {
        renderRatingList();
        showSelectableList(ratingList);
      });
    }

    if (sizeSearch) {
      sizeSearch.addEventListener('input', () => {
        renderSizeList();
        showSelectableList(sizeList);
      });
      sizeSearch.addEventListener('focus', () => {
        renderSizeList();
        showSelectableList(sizeList);
      });
      sizeSearch.addEventListener('click', () => {
        renderSizeList();
        showSelectableList(sizeList);
      });
    }
  };

  modal.addEventListener('click', (event) => {
    const target = event.target;
    const removePillButton = target && typeof target.closest === 'function'
      ? target.closest('.remove-pill-btn')
      : null;

    if (removePillButton) {
      const pill = removePillButton.closest('.filter-pill');
      if (!pill) return;

      const name = pill.getAttribute('data-pill-type');
      const value = pill.getAttribute('data-pill-value');
      if (!name || !value) return;

      const matchingCheckbox = Array.from(
        modal.querySelectorAll(`input[name="${name}"]`)
      ).find((input) => input.value === value);

      if (matchingCheckbox) {
        matchingCheckbox.checked = false;
        matchingCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const clickedSelectableInput =
      target === stateSearch ||
      target === citySearch ||
      target === ratingSearch ||
      target === sizeSearch;

    const clickedInsideList = selectableLists.some((listEl) => listEl.contains(target));

    if (!clickedSelectableInput && !clickedInsideList) {
      hideAllSelectableLists();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.style.display !== 'none') {
      closeModal();
    }
  });

  bindSearch();

  suppressBrowserAutofill([
    stateSearch,
    citySearch,
    ratingSearch,
    sizeSearch,
    buyInMinInput,
    buyInMaxInput
  ]);
})();
